import { render, staticRenderFns } from "./ToiletCreateScreen.vue?vue&type=template&id=c8c49b3c&scoped=true&lang=pug"
import script from "./ToiletCreateScreen.vue?vue&type=script&lang=ts"
export * from "./ToiletCreateScreen.vue?vue&type=script&lang=ts"
import style0 from "./ToiletCreateScreen.vue?vue&type=style&index=0&id=c8c49b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c49b3c",
  null
  
)

export default component.exports